import React, { useState } from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage, showLayer } from '@/utils/layer'
import { Column, Expaned, Row } from '@/components/layout/layout'
import Button from '@/components/button/button'
import { Table, Spin } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { $post } from '@/api'
import $msg from '@/utils/message'
import { createUseStyles } from 'react-jss'
import { useRequest } from 'ahooks'
import { Group, SecondaryGroup } from '@/model/types/goods'
import { Cascader } from 'antd'
import { goodsModel } from '../modules/edit-goods/modules/model'
import { goodsLibraryStore } from '../store/goods-library'
import { Modal } from '@/components/dialog/modal'

interface groupStatus {
    status: 0 | -1 //  {"0": "正常", "-1": "已删除"}
}

interface IBinGoods {
    id: number
    name: string
    group: Group & groupStatus
    delete_time: string
    secondary_group: SecondaryGroup & groupStatus
}

interface IBinObj {
    delete_goods_day: string
    delete_goods_list: IBinGoods[]
}

const styles = createUseStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '666px',
        height: '480px',
        borderRadius: '10px',
        overflow: 'hidden',
        border: '1px solid rgba(0, 0, 0, 0.1)',
    },

    footer: {
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '60px',
        padding: '0 16px',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    },

    inputContainer: {
        height: '24px',

        '& .ant-cascader-picker-label': {
            color: '#3c90ff',
        },

        '& .ant-cascader-picker': {
            minWidth: '70px',
            marginLeft: '4px',
        },

        '& .ant-select-selection-search': {
            left: '0 !important',
        },

        '& .ant-input': {
            padding: '0 !important',
            border: 'none !important',
            outline: 'none !important',
            boxShadow: 'none !important',

            '&::placeholder': {
                color: '#3c90ff',
            },
        },
    },

    tag: {
        width: '60px',
        height: '20px',
        borderRadius: '10px',
        backgroundColor: '#f7f7f7',
        color: '#999',
        fontSize: '14px',
        marginLeft: '4px',
    },

    group: {
        width: '110px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
})

const RecycleBin = () => {
    const [selectKeys, setSelectKeys] = useState<(number | string)[]>([])
    const [binGoods, setBinGoods] = useState<IBinGoods[]>([])
    const [groups, setGroups] = useState<number[]>([])
    const [filterArr, setFilterArr] = useState<
        {
            text: string
            value: string
        }[]
    >([])
    const classes = styles(selectKeys)
    const recorverRequest = useRequest(
        () =>
            $post({
                url: '/goods/recoverdeletegoods',
                params: {
                    goods_list: selectKeys,
                    group_id: groups[0],
                    secondary_group_id: groups[1],
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                layerManage.pop()
                goodsLibraryStore.setUpdateGroupStatus(!goodsLibraryStore.updateGroupStatus)
            },
        },
    )
    // 确认提交
    const confirmEvent = () => {
        showLayer(
            <Modal
                headerStyles={{ width: '440px' }}
                isShow
                type="danger"
                style={{ height: '156px' }}
                onClose={() => layerManage.pop()}
                onCancel={() => layerManage.pop()}
                onConfirm={() => {
                    layerManage.pop()
                    recorverRequest.run()
                }}
            >
                <div>
                    <div data-font-size-20 data-font-weight-600 data-color-000>
                        确认恢复选中的{selectKeys.length}种商品吗？
                    </div>
                    <div data-font-size-14 data-color-999 data-margin-top-8>
                        选中的商品将恢复至未上架的状态
                    </div>
                </div>
            </Modal>,
        )
    }

    const requestHandle = useRequest(
        () => {
            return $post({
                url: '/goods/getdeletegoods',
            })
        },
        {
            onSuccess: (res: IBinObj[]) => {
                // 数据格式转换
                let binGoodsContext: IBinGoods[] = []
                const filterArrContext: {
                    text: string
                    value: string
                }[] = []
                res.forEach(item => {
                    const addTimeGoodsList = item.delete_goods_list.map(i => ({
                        ...i,
                        delete_time: item.delete_goods_day,
                    }))
                    binGoodsContext = binGoodsContext.concat(addTimeGoodsList)
                    filterArrContext.push({
                        text: item.delete_goods_day,
                        value: item.delete_goods_day,
                    })
                })
                setBinGoods(binGoodsContext)
                setFilterArr(filterArrContext)
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    const columns: ColumnsType<IBinGoods> = [
        {
            title: '#',
            width: '40px',
            render: (value, record, index) => index + 1,
        },
        {
            title: '商品名',
            dataIndex: 'name',
            ellipsis: {
                showTitle: true,
            },
        },
        {
            title: '删除时间',
            dataIndex: 'delete_time',
            filters: filterArr,
            onFilter: (record, value) => value.delete_time === record,
        },
        {
            title: '删前分组',
            width: '180px',
            render: (values, record) => {
                const hasSecondGroup = !!Object.keys(record.secondary_group).length

                return (
                    <Row>
                        <div className={classes.group}>{`${record.group.name}${
                            hasSecondGroup ? '/' + record.secondary_group.name : ''
                        }`}</div>
                        {(hasSecondGroup ? record.secondary_group.status === -1 : record.group.status === -1) && (
                            <div className={classes.tag} data-center>
                                不存在
                            </div>
                        )}
                    </Row>
                )
            },
        },
    ]

    return (
        <BaseDialog
            styles={{ width: '714px' }}
            isShow
            title="回收站"
            renderTitle={() => (
                <span data-margin-left-8 data-font-size-14 data-color-999>
                    仅保存7天内删除的商品
                </span>
            )}
            onClose={() => layerManage.pop()}
        >
            <Spin spinning={requestHandle.loading}>
                <Column data-padding-h-24 data-padding-top-16 data-padding-bottom-32>
                    <div className={classes.wrapper}>
                        <Expaned>
                            <Table
                                locale={{
                                    filterConfirm: '确认',
                                    filterReset: '重置',
                                    filterEmptyText: '暂无数据',
                                }}
                                dataSource={binGoods}
                                rowKey={record => record.id}
                                columns={columns}
                                pagination={false}
                                bordered
                                rowSelection={{
                                    type: 'checkbox',
                                    onChange: selectedRowKeys => {
                                        setSelectKeys(selectedRowKeys)
                                    },
                                }}
                                scroll={{ y: 380 }}
                            />
                        </Expaned>
                        <Row className={classes.footer}>
                            <Row data-align-items-center>
                                {!!selectKeys.length && (
                                    <>
                                        <span data-font-size-14 data-color-000 data-row data-align-items-center>
                                            已选
                                            <span data-margin-h-5 data-color-primary>
                                                {selectKeys.length}
                                            </span>
                                            个商品，恢复至
                                        </span>
                                        <div className={classes.inputContainer}>
                                            <Cascader
                                                placeholder="请选择"
                                                onChange={(e: any) => {
                                                    setGroups(e as number[])
                                                }}
                                                suffixIcon={
                                                    <i data-color-blue className="iconfont icon6xiala2-202"></i>
                                                }
                                                options={goodsModel.goodsGroup as any}
                                                fieldNames={{
                                                    label: 'name',
                                                    value: 'id',
                                                    children: 'secondary_group',
                                                }}
                                            />
                                        </div>
                                    </>
                                )}
                            </Row>
                            <Button
                                types="default"
                                disabled={!selectKeys.length || !groups.length}
                                onClick={confirmEvent}
                                loading={recorverRequest.loading || undefined}
                            >
                                确认
                            </Button>
                        </Row>
                    </div>
                </Column>
            </Spin>
        </BaseDialog>
    )
}

export default RecycleBin
